import { render, staticRenderFns } from "./TabContainerModal.vue?vue&type=template&id=ce4ef4d8&"
import script from "./TabContainerModal.vue?vue&type=script&lang=js&"
export * from "./TabContainerModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports